<template>
  <div class="mx-5">
    <v-row class="pt-2">
      <v-col cols="12" md="5" class="pa-0">
        <p class="d-flex text-h6 text-md-h5 font-weight-bold text-center mb-0">
          <i class="d-flex mr-3">
            <v-icon color="red" class="text-h5 text-md-h4">mdi-map-marker</v-icon>
          </i>
          <span v-if="this.currentPointSequence === 1">{{this.currentPoint}} からスタート！</span>
          <span v-else>{{this.currentPoint}}に到着しました！</span><br>
        </p>
        <p v-if="this.isLastPoint && !this.isFirstGoal" class="text-center mb-0 ml-4 ml-md-12 text-h6">
          次の目的地「<span class="font-weight-bold">{{this.nextPoint}}</span>」まで残り<span class="font-weight-bold">{{numberOfStepsRemainingToDestination.toLocaleString()}}</span>歩！
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <p class="number_of_steps font-weight-bold rounded-xl text-center mb-1">あなたの累計歩数</p>
        <p class="text-h5 text-center mb-0">{{this.numberOfSteps.toLocaleString()}}歩</p>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <p class="moving_distance font-weight-bold rounded-xl text-center mb-1">あなたの推定移動距離</p>
        <p class="text-h5 text-center mb-0">{{Math.floor(this.numberOfSteps * this.strideLength * 10) / 10}}km</p>
      </v-col>
    </v-row>

    <v-row class="mt-4">
      <v-col cols="12" md="5" style="display: flex; justify-content: center;">
        <div style="width: 350px; max-width: 350px !important; padding: 0 !important;">
          <HanshinshikokusetouchiMap
            :arrivedPointIdList="arrivedPointIdList"
            :isDetail='true'
            :currentPointSequence='currentPointSequence'
            :isSecondGoalEnabled="isSecondGoalEnabled"
            @clickedPointId="changeDetail"
          />
        </div>
      </v-col>
      <v-col cols="12" md="7" class="pt-8 pt-md-3">
        <p class="text-h5 text-center font-weight-bold">「{{this.selectedPointName}}」の{{this.selectedPointSpecialty}}</p>
        <div class="target-img waku">
          <v-img :src="this.imgUrl"/>
        </div>
        <div class="py-4">
          <span>{{this.selectedPointDetail}}</span>
        </div>
      </v-col>
    </v-row>
      </div>
</template>

<script>
const HanshinshikokusetouchiMap = () => import('./HanshinshikokusetouchiMap')

export default {
  name: 'walkingTravelDetail',
  data () {
    return {
      selectedPointName: '',
      selectedPointSpecialty: '',
      selectedPointDetail: '',
      imgUrl: '',
      nextPoint: '',
      isLastPoint: false
    }
  },
  props: [
    'walkingTravelPointList',
    'numberOfSteps',
    'strideLength',
    'currentPoint',
    'currentPointSequence',
    'arrivedPointIdList',
    'firstGoalSequence',
    'isSecondGoalEnabled',
    'walkingDialog'
  ],
  components: {
    HanshinshikokusetouchiMap
  },
  watch: {
    numberOfSteps: {
      handler (newValue) {
        this.setPointInfo()
      }
    },
    currentPointSequence (newValue) {
      this.setPointInfo()
    },
    walkingDialog (newValue) {
      if (newValue) {
        this.enableSecondGoalWhenFirstGoalIsReached()
      }
    }
  },
  async created () {
    this.setPointInfo()
    this.enableSecondGoalWhenFirstGoalIsReached()
  },
  methods: {
    setPointInfo () {
      this.setPointDetailInfo(this.walkingTravelPointList[this.currentPointSequence - 1])
      if (this.walkingTravelPointList.length > this.currentPointSequence) {
        this.nextPoint = this.walkingTravelPointList[this.currentPointSequence].point_name
        this.isLastPoint = true
      } else {
        this.isLastPoint = false
      }
    },
    changeDetail (clickedPointId) {
      for (const point of this.walkingTravelPointList) {
        if (point.sequence === clickedPointId) {
          this.setPointDetailInfo(point)
        }
      }
    },
    setPointDetailInfo (point) {
      this.selectedPointName = point.point_name
      this.selectedPointSpecialty = point.specialty
      this.selectedPointDetail = point.point_detail
      this.imgUrl = './image/hanshinshikokusetouchi/' + point.point_image_path + '.jpg'
    },
    enableSecondGoalWhenFirstGoalIsReached () {
      if (this.isFirstGoal) {
        this.$emit('setFirstGoalAchievedPopUp', true)
      }
    }
  },
  computed: {
    numberOfStepsRemainingToDestination () {
      const nextDestination = this.walkingTravelPointList.find(item => item.sequence === this.currentPointSequence + 1)
      if (!nextDestination) {
        return 0
      }
      const totalStepsToDestination = Math.ceil(nextDestination.distance / this.strideLength)
      return Math.ceil(totalStepsToDestination - this.numberOfSteps)
    },
    isFirstGoal () {
      return (!this.isSecondGoalEnabled && this.firstGoalSequence === this.currentPointSequence)
    }
  }
}
</script>

<style lang="scss">
  .number_of_steps {
    background-color: rgb(255, 210, 127);
  }
  .moving_distance {
    background-color: rgb(255, 193, 127);
  }
  .target-img.waku {
    border: 10px solid #fff;
    box-shadow: 0 0 0 1px #ccc,1px 3px 8px 0 rgba(40,40,40,0.3);
    max-width: 550px;
    margin: 26px auto;
  }
  .v-dialog > .v-card > .v-card__text {
    padding-top : 10px;
    @media (max-width:600px) {
      padding : 0;
    }
  }
</style>
